var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h3',{staticClass:"notAllowed text-center"},[_vm._v("Su contraseña ha sido cambiada")])])
}
var staticRenderFns = []

export { render, staticRenderFns }